import type { IconProps } from './IconProps';

export const FeedbackIcon = (props: IconProps) => (
  <svg
    viewBox="1.3 0.8 8.5 9.5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 16}
    height={props.height ?? 16}
    {...props}
  >
    <path
      d="M6.95505 3.86999H4.14252M6.95505 5.92614H4.14252M5.5478 9.7998L6.83218 8.63289C6.9163 8.55652 7.02205 8.51474 7.13124 8.51474H7.89355C8.67018 8.51467 9.2998 7.82427 9.2998 6.97257V2.84191C9.2998 1.99023 8.67018 1.2998 7.89355 1.2998L3.20605 1.29981C2.4294 1.29982 1.7998 1.99024 1.7998 2.84193V6.97257C1.7998 7.82427 2.4294 8.51474 3.20605 8.51474H3.97931C4.08944 8.51474 4.19604 8.55724 4.28044 8.63478L5.5478 9.7998Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
